module.exports = __webpack_public_path__ + "static/img/service_bg.170ee02.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/publicService/service_bg.jpg
// module id = hWDl
// module chunks = 2